import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RequestFilter } from '@shared/entities/requestFilter';
import { ApiService } from '@shared/services';
import { BehaviorSubject, Observable, Subject, shareReplay, switchMap, take, tap } from 'rxjs';
import { RequestFilterURL } from './request-info.service';

const LOG_PREFIX = '[Api][RequestFilters] ';

@Injectable({
  providedIn: 'root'
})
export class RequestInfoFiltersFinalUsersService extends ApiService<RequestFilter> {
  private refresh$: Subject<boolean>;
  all$: Observable<RequestFilter>;
  currentFilters: RequestFilterURL = {};

  set filters(value: RequestFilterURL) {
    this.currentFilters = value;
    this.refresh(true);
  }

  constructor(private activatedRoute: ActivatedRoute) {
    const masterUrl = '/info-request/filters';
    const detailUrl = '/info-request/filters';

    super(RequestFilter, masterUrl, detailUrl);

    this.refresh$ = new BehaviorSubject<boolean>(true);

    this.all$ = this.refresh$.pipe(
      switchMap(() => {
        const { locationId } = this.activatedRoute.snapshot.queryParams;
        if (locationId) {
          this.setUrlParameter('locationId', locationId);
        }
        if (this.currentFilters.caseNumber) {
          this.setUrlParameter('caseNumber', this.currentFilters.caseNumber);
        }
        if (this.currentFilters.serialNumber) {
          this.setUrlParameter('serialNumber', this.currentFilters.serialNumber);
        }
        if (this.currentFilters.reason) {
          this.setUrlParameter('reason', this.currentFilters.reason);
        }
        this.setUrlParameter('order_by', this.currentFilters.orderBy || 'createdDate');
        if (this.currentFilters.orderBy) {
          this.setUrlParameter('direction', 'ASC');
        }
        return this.findOne('');
      }),
      tap({
        next: (result) => this.logger.debug(LOG_PREFIX + 'all$', result),
        error: (err) => this.logger.error(LOG_PREFIX + 'all$ error', err)
      }),
      shareReplay(1)
    );
  }

  refresh(value: boolean) {
    this.logger.debug(LOG_PREFIX + 'refresh');
    this.refresh$.next(value);

    return this.all$.pipe(take(1));
  }
}
